import React, { useState } from "react";

export default function BlogPromoSubscription() {
    const [email, setEmail] = useState("");
    const [policyAccepted, setPolicyAccepted] = useState(false);
    const [errors, setErrors] = useState({ email: false, privacy: false });
    const [isSubscribed, setIsSubscribed] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasError = false;
        let newErrors = { email: false, privacy: false };

        if (!email) {
            newErrors.email = true;
            hasError = true;
        }
        if (!policyAccepted) {
            newErrors.privacy = true;
            hasError = true;
        }
        setErrors(newErrors);

        if (hasError) return;

        try {
            await fetch("/api/blogsubscription", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            setIsSubscribed(true);
        } catch (err) {
            setErrors({ ...newErrors, email: "Hiba történt a feliratkozáskor." });
        }
    };

    return (
        <div className="blog-promo-subscription">
            <div className="blog-promo-subscription__inner">
                <img src="/images/blog-promo-subscription.svg" alt="Blog Promo Illustration" />
                <form
                    className="blog-promo-subscription__content"
                    onSubmit={handleSubmit}
                    autoComplete="off"
                >
                    <div>
                        <h3>Imádod a digitális könyveket és mindig naprakész akarsz lenni?</h3>
                        <p>
                            Iratkozz fel a DiBook Blogra, és értesülj elsőként a legfrissebb interjúkról, könyvajánlókról és más e-könyves érdekességekről! Ne maradj le semmiről, ami a könyvek világában történik!
                        </p>
                    </div>
                    {!isSubscribed ? (
                        <>
                            <div className="blog-promo-subscription__form-row">
                                <input
                                    type="email"
                                    placeholder="E-mail-cím"
                                    value={email}
                                    className={errors.email ? "has-error" : ""}
                                    onChange={e => {
                                        setEmail(e.target.value);
                                        setErrors({ ...errors, email: false });
                                    }}
                                />
                                <button type="submit">
                                    FELIRATKOZOM A BLOGRA
                                </button>
                            </div>
                            {errors.email && (
                                <div className="blog-promo-subscription__error">
                                    Kérjük, adj meg egy e-mail címet!
                                </div>
                            )}
                            <div className="blog-promo-subscription__checkbox-row">
                                <input
                                    type="checkbox"
                                    id="promo-gdpr"
                                    checked={policyAccepted}
                                    onChange={e => {
                                        setPolicyAccepted(e.target.checked);
                                        setErrors({ ...errors, privacy: false });
                                    }}
                                />
                                <label htmlFor="promo-gdpr" className={errors.privacy ? "has-error" : ""}>
                                    Az{" "}
                                    <a
                                        href="https://dibook.hu/storage/static/GDPR.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Adatvédelmi Tájékoztatót
                                    </a>{" "}
                                    elolvastam és elfogadom.
                                </label>
                            </div>
                            {errors.privacy && (
                                <div className="blog-promo-subscription__error">
                                    Kérjük, fogadd el az Adatvédelmi Tájékoztatót!
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="blog-promo-subscription__success">
                            Sikeresen feliratkoztál!
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}
